import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ApplicationInformationService } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { PageManager } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandPrintReportTemplateDesignPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandPrintReportTemplateDesignProperties = {
    [name in keyof EntityCommandPrintReportTemplateDesignPropertyValues]: Property<EntityCommandPrintReportTemplateDesignPropertyValues[name]>
};

export interface IEntityCommandPrintReportTemplateDesign extends IEntityCommand, EntityCommandPrintReportTemplateDesignProperties
{
}

export class EntityCommandPrintReportTemplateDesign extends EntityCommand implements IEntityCommandPrintReportTemplateDesign
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandPrintReportTemplateDesign";
    public static override className = "EntityCommandPrintReportTemplateDesign";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandPrintReportTemplateDesignPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Design",
                entityName: "PrintReportTemplate",
                isDefault: true,
                key: "DESIGN",
                permission: PermissionEvaluator.permissionLevels.update,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandPrintReportTemplateDesignPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        PageManager.instance?.navigateAsync(
                            StringHelper.format(
                                "{0}modules/reports/printreportdesigner/{1}/",
                                ServiceManager.getRequired(ApplicationInformationService).virtualDirectory,
                                recordId
                            )
                        )
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

